import { useEffect } from 'react';

// Tipos de enlace de contacto -> nombre del evento de GA4.
const LINK_EVENTS = [
  { name: 'whatsapp_click', test: (href) => /^https:\/\/wa\.me\//.test(href) },
  { name: 'phone_click', test: (href) => href.startsWith('tel:') },
  { name: 'email_click', test: (href) => href.startsWith('mailto:') },
  { name: 'instagram_click', test: (href) => /^https:\/\/(www\.)?instagram\.com\//.test(href) },
];

// Dónde está el enlace: pie, menú, una sección de la home o la ficha de una propiedad.
const locationOf = (link) => {
  if (link.closest('footer')) return 'footer';
  if (link.closest('nav')) return 'menu';
  if (link.closest('.property-page-card')) return 'property_page';
  const section = link.closest('section[id]');
  return section ? section.id : 'other';
};

export const sendEvent = (name, params) => {
  // gtag se define en index.html y encola en dataLayer aunque gtag.js aún no se haya cargado.
  if (typeof window.gtag === 'function') window.gtag('event', name, params);
};

// Un solo detector de clics para todos los enlaces de contacto, presentes y futuros.
// No se envía la URL del enlace ni el texto del mensaje de WhatsApp. En teléfono y correo
// tampoco el texto visible del enlace, que es el propio número o correo.
export function useContactTracking() {
  useEffect(() => {
    const onClick = (e) => {
      const link = e.target.closest && e.target.closest('a[href]');
      if (!link) return;
      const href = link.getAttribute('href') || '';
      const kind = LINK_EVENTS.find((k) => k.test(href));
      if (!kind) return;

      const match = window.location.pathname.match(/^\/propiedades\/([^/]+)/);
      const params = {
        link_location: locationOf(link),
        page_type: match ? 'property' : 'home',
        transport_type: 'beacon',
      };
      if (kind.name === 'whatsapp_click' || kind.name === 'instagram_click') {
        params.link_text = (link.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 50);
      }
      if (match) params.property_slug = match[1];
      sendEvent(kind.name, params);
    };

    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);
}
